<template>
  <dashboard-widget title="EXCISE SPIRITS" :zoomed="zoomed" :width="width" :enableDelete="enableDelete"
                      @zoom="$emit('zoom','DashboardExciseSpirits')"
                      @delete="$emit('delete','DashboardExciseSpirits')"
                      @close="$emit('close')">
    <v-autocomplete v-if="licenses.length > 1" :items="licenses" v-model="license" hide-details dense class="d-inline-block"
              style="position:absolute;top:10px;right:40px;width:120px" @change="draw()"/>
    <div :class="{'text-caption':!zoomed,'text-body':zoomed}">Total {{total | number(3)}} LAA</div>
    <div class="text-center">
      <div ref="chart" class="d-inline-block" :style="zoomed?'height:400px;width:420px':'height:230px;width:230px'"/>
    </div>
  </dashboard-widget>
</template>

<script>
export default {
  name: 'DashboardExciseSpirits',
  props: {
    width: {type:Number, required:false, default:290},
    zoomed: {type:Boolean, required:false, default:false},
    enableDelete: {type: Boolean, required:false, default:false}
  },
  data() {
    return {
      laa: [],
      license: null,
      licenses: [],
      total: 0,
      chart: null,
      options:  {chartArea:{height:'100%',width:'100%'},
                 fontSize:this.zoomed?14:12,
                 pieSliceText:'label',
                 pieSliceTextStyle: {color:'#000'},
                 pieHole: 0.5,
                 colors: ['#29B6F6','#26C6DA','#26A69A'],
                 legend:{ position: 'none'}}
    }
  },
  computed: {
    sites() {
      return this.$store.getters.sites(true, {B266:true});
    }
  },
  watch: {
    dark() {
      this.draw();
    }
  },
  async mounted() {
    const results = await this.$apiCall(`query DashboardExciseSpirits {
                                          exciseSpiritsSummary {
                                            license,vesselType,laa
                                          }
                                         }`, {});
    if (!results.error) {
      this.laa = results.data.exciseSpiritsSummary;
      this.licenses = [...new Set(this.sites.map(site => site.spiritsLicense))];
      this.license = this.licenses[0];

      if (window.google) {
        window.google.charts.load('current', {'packages':['corechart']});
        window.google.charts.setOnLoadCallback(() => {
          if (this.$refs.chart == undefined)
            return;
          this.chart = new window.google.visualization.PieChart(this.$refs.chart);
          this.draw();
          google.visualization.events.addListener(this.chart, 'select', () => {
            const selectedItem = this.chart.getSelection()[0];
            if (selectedItem)
              this.$router.push({name:['EquipmentTanks','InventoryCasks','InventoryBulkContainers'][selectedItem.row],
                                  query:{siteId:this.sites.find(site => site.spiritsLicense === this.license).id,
                                         status:'2', contents:'1', license:'0'}
                                });
          });
        });
      }
    }
  },
  methods: {
    draw() {
      if (this.chart === null)
        return;

      const data = [
                    ['TYPE', 'LAA'],
                    ['Tanks', 0],
                    ['Casks', 0],
                    ['Bulk\rcontainers', 0]
                  ];
      this.total = 0;
      this.laa.forEach(l => {
        if (this.license === l.license) {
          switch(l.vesselType) {
            case 'Tank':
              data[1][1] += l.laa;
              break;
            case 'Cask':
              data[2][1] += l.laa;
              break;
            case 'BulkContainer':
              data[3][1] += l.laa;
              break;
          }
          this.total += l.laa;
        }
      });

      const dataTable = window.google.visualization.arrayToDataTable(data);
      new window.google.visualization.NumberFormat({fractionDigits:3}).format(dataTable, 1);
      this.chart.draw(dataTable, {...this.options, backgroundColor:this.darkMode?'#1e1e1e':'white'});
    }
  }
}
</script>